import InputAutocompleteAreas from "#core/inputs/autocomplete/InputAutocompleteAreas"
import InputAutocompleteSucursales from "#core/inputs/autocomplete/InputAutocompleteSucursales"
import SelectCategory from "#training/components/SelectCategory"
import StatisticsGraph from "#training/components/statistics/StatisticsGraph"
import StatisticsTable from "#training/components/statistics/StatisticsTable"
import { Box, Paper, Skeleton, Stack } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useMemo, useState } from "react"

const Statistics = () => {
	ChangeTitle("Estadísticas de Capacitación")
	const [params, setParams] = useState({
		departamento: [],
		sucursal: [],
		category_id: "",
	})
	const [loading, setLoading] = useState({})
	const view = useMemo(() => {
		return !(loading.category && loading.areas && loading.sucursales)
	}, [loading])

	return (
		<Box>
			<Stack spacing={2} direction={"column"}>
				<Box component={Paper} sx={{ p: 2 }}>
					<Stack spacing={2} direction={"row"}>
						<SelectCategory
							fullWidth
							value={params.category_id}
							setValue={(category_id) => {
								setParams({ ...params, category_id })
							}}
							getData={(data) => {
								if (data[0]?.id !== params.category_id)
									setParams((old) => ({ ...old, category_id: data[0]?.id }))
							}}
							getLoading={(loading) => {
								setLoading((old) => ({ ...old, category: loading }))
							}}
						/>
						<InputAutocompleteAreas
							multiple
							setValue={(value) => {
								setParams((old) => ({ ...old, departamento: value }))
							}}
							getLoading={(loading) => {
								setLoading((old) => ({ ...old, departamento: loading }))
							}}
						/>
						<InputAutocompleteSucursales
							multiple
							setSelectedSucursales={(value) => setParams({ ...params, sucursal: value })}
							getLoading={(loading) => {
								setLoading((old) => ({ ...old, sucursal: loading }))
							}}
						/>
					</Stack>
				</Box>
				<br />

				{!view && <Skeleton variant="rectangular" height={"70vh"} />}
				{view && <StatisticsTable autoFetch={view} params={params} />}
				{view && <StatisticsGraph autoFetch={view} params={params} />}
			</Stack>
		</Box>
	)
}
export default Statistics
